<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="open()"
      >新增</el-button
    >

    <el-dialog
      title="新增国际化配置"
      width="800px"
      :visible.sync="dialogVisible"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="descCode" prop="descCode">
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="ruleForm.descCode"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="descUse" prop="descUse">
          <el-input
            type="textarea"
            placeholder="请输入用途说明"
            v-model="ruleForm.descUse"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="中文" prop="chinese">
          <el-input
            type="textarea"
            placeholder="请输入中文"
            v-model="ruleForm.chinese"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="繁体" prop="hongkong">
          <el-input
            type="textarea"
            placeholder="请输入繁体"
            v-model="ruleForm.hongkong"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="英语" prop="english">
          <el-input
            type="textarea"
            placeholder="请输入英语"
            v-model="ruleForm.english"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="日语" prop="japanese">
          <el-input
            type="textarea"
            placeholder="请输入日语"
            v-model="ruleForm.japanese"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="韩语" prop="korean">
          <el-input
            type="textarea"
            placeholder="请输入韩语"
            v-model="ruleForm.korean"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="俄语" prop="russian">
          <el-input
            type="textarea"
            placeholder="请输入俄语"
            v-model="ruleForm.russian"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="越南语" prop="vietnam">
          <el-input
            type="textarea"
            placeholder="请输入越南语"
            v-model="ruleForm.vietnam"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="印地语" prop="hindi">
          <el-input
            type="textarea"
            placeholder="请输入印地语"
            v-model="ruleForm.hindi"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="印尼" prop="indonesian">
          <el-input
            type="textarea"
            placeholder="请输入印尼"
            v-model="ruleForm.indonesian"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="西班牙语" prop="spanish">
          <el-input
            type="textarea"
            placeholder="请输入西班牙语"
            v-model="ruleForm.spanish"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="土耳其语" prop="turkish">
          <el-input
            type="textarea"
            placeholder="请输入土耳其"
            v-model="ruleForm.turkish"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="泰语" prop="thailand">
          <el-input
            type="textarea"
            placeholder="请输入泰语"
            v-model="ruleForm.thailand"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="葡萄牙语" prop="portugal">
          <el-input
            type="textarea"
            placeholder="请输入葡萄牙语"
            v-model="ruleForm.portugal"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="阿拉伯语" prop="arab">
          <el-input
            type="textarea"
            placeholder="请输入阿拉伯语"
            v-model="ruleForm.arab"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="法语" prop="french">
          <el-input
            type="textarea"
            placeholder="请输入法语"
            v-model="ruleForm.french"
            show-word-limit
          >
          </el-input>
        </el-form-item>

        <el-form-item label-width="300px">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定添加</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import {
  ValidateCode,
  ValidateEN,
  ValidateLocale,
  ValidateZH,
} from "../../validate.js";
export default {
  props: ["currentSize", "currentPage", "descCode", "chinese"],
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        descCode: "",
        descUse: "",
        chinese: "",
        english: "",
        japanese: "",
        korean: "",
        turkish: "",
        vietnam: "",
        russian: "",
        hongkong: "",
        hindi: "",
        indonesian: "",
        spanish: "",
        thailand: "",
        portugal: "",
        arab: "",
        french: "",
      },
      arr: [],
      result: false,
      rules: {
        descCode: [
          { required: true, message: "请输入descCode", trigger: "blur" },
        ],
        english: [
          // { required: true, validator: ValidateEN, trigger: "blur" },
          { required: true, message: "请输入英文内容", trigger: "blur" },
        ],
        chinese: [
          { required: true, message: "请输入中文内容", trigger: "blur" },
          // { required: true, validator: ValidateZH, trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.ruleForm = {
      descCode: "",
      descUse: "",
      chinese: "",
      english: "",
      japanese: "",
      korean: "",
      turkish: "",
      vietnam: "",
      russian: "",
      hongkong: "",
      hindi: "",
      indonesian: "",
      spanish: "",
      thailand: "",
      portugal: "",
      arab: "",
      french: "",
    };
  },
  methods: {
    ...mapActions("config-i18n", ["addOne", "getlist"]),
    handleSave() {
      this.dialogVisible = false;
      this.$message.success("已添加");
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
          this.resetForm("ruleForm");
        })
        .catch((_) => {});
    },
    closeDialog() {
      this.resetForm("ruleForm");
    },
    open() {
      this.dialogVisible = true;
    },
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate(async (valid) => {
        if (valid) {
          const res = await this.addOne({
            ...this.ruleForm,
          });
          if (res.code == 0) {
            this.dialogVisible = false;
            this.getlist({
              descCode: this.descCode,
              chinese: this.chinese,
              page: this.currentPage,
              size: this.currentSize,
            });
            this.resetForm("ruleForm");
            this.$message.success("添加成功");
          }
          if (res.code == -1) {
            this.resetForm("ruleForm");
            this.dialogVisible = false;
            this.$message.error(res.msg);
          }
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="less" scoped></style>
